export default __webpack_public_path__ + "b18a96e0f7af55c51c5a622a8edd30cf.png";